import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag: number | string;
  rowVersion: string;
};

const deleteImplementation = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  benefitImplementationTag,
  rowVersion,
}: Params) => {
  const response = await api.patch(
    `/benefitimplementation/delete/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}`,
    {
      rowVersion,
    }
  );
  return response.data;
};

export function useDeleteBenefitImplementation(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitImplementations =
    useInvalidateBenefitImplementations();

  return useMutation(deleteImplementation, {
    mutationKey: MUTATION_KEYS.deleteBenefitImplementation,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitImplementations();
      }
      // queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategories });
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
